import React, { Component } from 'react'

import { throttle } from 'lodash'
import { getDistanceFromTop } from '../../utils/position.js'

import './Watermark.css'

class Watermark extends Component {

    constructor(props) {
        super(props)

        this.state = {
            show: false
        }

        this.scroll = this.scroll.bind(this)
        this.bind = this.bind.bind(this)
        this.removeBind = this.removeBind.bind(this)
        
    }


  


    scroll(e) {

        const top = getDistanceFromTop()
        const { viewport } = this.props

        const show = top > viewport.height ? true : false

        this.setState({
            show
        });

    }


    componentDidMount() {

        this.cb = throttle(this.scroll);
        this.bind();

    }

    componentWillUnmount() {
        this.removeBind();
    }


    bind() {
        window.addEventListener('scroll', this.cb);
    }

    removeBind() {
        window.removeEventListener('scroll', this.cb);
    }


    render() {

        const { txt } = this.props
        const { show } = this.state

        const watermarkStyles = {
            opacity: show ? 1 : 0
        }

        return (

            <div className="watermark" style={watermarkStyles}>

                {txt}

            </div>


        );
    }
}


export default Watermark;